let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("63A51")).then(() => parcelRequire('372Q4'));